/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import CustomFormsService from 'cio/services/custom-forms';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';
import AuthService from 'cio/services/auth';

interface FormsFormsHeaderArgs {
  connectFormFacebook: () => unknown;
  connectFormCustom: () => unknown;
  connectFormTypeform: () => unknown;
  connectFormJotform: () => unknown;
}

export default class FormsFormsHeader extends Component<FormsFormsHeaderArgs> {
  @service auth!: AuthService;
  @service analytics!: AnalyticsService;
  @service customForms!: CustomFormsService;
  @service facebookLeadAds!: FacebookLeadAdsService;

  @tracked showFeedbackModal = false;

  get dropdownOptions() {
    return [
      this.facebookLeadAds.isAvailable
        ? {
            label: 'Facebook Lead Ads',
            action: () => this.args.connectFormFacebook(),
            disabled: this.facebookLeadAds.enabled && !this.facebookLeadAds.hasFormsToConnect,
            tooltip: {
              condition: this.facebookLeadAds.enabled && !this.facebookLeadAds.hasFormsToConnect,
              content: 'There are no available forms to connect.',
            },
          }
        : null,
      {
        label: 'Custom form',
        action: () => this.args.connectFormCustom(),
      },
      {
        label: 'Typeform',
        action: () => this.args.connectFormTypeform(),
      },
      {
        label: 'Jotform',
        action: () => this.args.connectFormJotform(),
      },
    ].compact();
  }

  @action
  toggleFeedbackModal() {
    if (!this.showFeedbackModal) {
      this.analytics.track('forms', 'feedback_request_started');
    }

    this.showFeedbackModal = !this.showFeedbackModal;
  }
}
